import '../styles/site-footer.css'

// Mirrors the <footer> markup in the static pages (public/index.html etc.)
// exactly — same classes, same brand blurb, same firm links, same
// broker-dealer legal disclosure — so the site reads as one continuous
// footer whether you're on a static page or in this SPA.
export default function SiteFooter() {
  return (
    <footer>
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <p>
              We are an independent investment bank advising founder-led companies, sponsors and boards on mergers,
              acquisitions and capital raises.
            </p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h5>Firm</h5>
              <a href="/financial-advisory">Financial Advisory</a>
              <a href="/industries">Industries</a>
              <a href="/transactions">Transactions</a>
              <a href="/approach">Approach</a>
              <a href="/insights">Insights</a>
              <a href="/contact">Contact</a>
            </div>
          </div>
        </div>
        <div className="footer-legal">
          © 2026 Selcius Partners LLC. All rights reserved.
          <br />
          Securities offered through{' '}
          <a href="https://www.frontiersecurities.com/" target="_blank" rel="noopener" style={{ textDecoration: 'underline' }}>
            Frontier Securities
          </a>
          , LLC (member{' '}
          <a href="https://www.finra.org/" target="_blank" rel="noopener" style={{ textDecoration: 'underline' }}>
            FINRA
          </a>
          , SIPC), 3307 Church Road, Suite 220, Richmond, VA 23233. Please refer to FINRA BrokerCheck for information
          about Frontier Securities, LLC.
        </div>
      </div>
    </footer>
  )
}
